<template>
  <div class="gardenDetail">
    <div class="garden-detail">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <!-- <el-breadcrumb-item :to="{ path: '/garden' }">园区</el-breadcrumb-item>
        <el-breadcrumb-item class="current-page">园区详情</el-breadcrumb-item> -->
      </el-breadcrumb>

      <div class="garden-detail-main">
        <div class="garden-tits">
          <p
            class="garden-tit"
            v-for="(item, index) in pageNavList"
            :key="index"
            :class="{ itemClick: itemClickItem === index }"
            @click="toModule(item.id, index)"
          >
            {{ item.name||"" }}
          </p>
        </div>
        <div class="garden-main">
          <div class="survey" id="survey">
            <span class="title" style="margin-top: 0">园区概况</span>
            <div class="garden-intro">
              <img class="garden-logo" v-if="gardenInfoList.logo" :src="gardenInfoList.logo" alt="" />
              <img class="garden-logo" v-else src="../../assets/home/lostImg.png" alt="" />
              <div class="base-info">
                <p class="info-tit">{{ gardenInfoList.name }}（{{ gardenInfoList.operationEntity }}）</p>
                <span class="tag-style" v-if="isBase">孵化基地</span>
                <span
                  class="tag-style"
                  v-for="(item, index) in gloryTag"
                  :key="index"
                >
                  {{ item }}
                </span>
                <p>
                  <img
                    class="icon"
                    src="@/assets/firm-garden/icon-site.png"
                    alt=""
                  />
                  <span class="icon-info">
                    {{ gardenInfoList.district + ' ' + gardenInfoList.districtDetail }}
                 </span>
                </p>
                <p>
                  <img
                    class="icon"
                    src="@/assets/firm-garden/icon-call.png"
                    alt=""
                  />
                  <span class="icon-info">{{ gardenInfoList.phone }}</span>
                </p>
                <p>
                  <img
                    class="icon"
                    src="@/assets/firm-garden/icon-web.png"
                    alt=""
                  />
                  <span class="icon-info">{{ gardenInfoList.url }}</span>
                </p>
              </div>
            </div>
            <p class="info-content">{{ gardenInfoList.basementDetail }}</p>
            <div class="Data">
                <!-- :class="{ itemHover: itemHoverIndex === item.index }"  划过块的高亮-->
              <p
                class="specificData"
                v-for="(item, index) in baseDataList"
                :key="index"
                @mouseenter="mouseEnter(item.index)"
                @mouseleave="mouseLeave"
              >
                <span class="DataNum" v-if="item.name === '建园时间'">
                  {{gardenInfoList.startDate ? gardenInfoList.startDate.split(' ')[0] :'-'}}
                </span>
                <span
                  class="DataNum"
                  v-if="item.name === '孵化面积（平方公里）'"
                  >{{ gardenInfoList.incubationArg01 ? gardenInfoList.incubationArg01 : '-' }}</span
                >
                <span class="DataNum" v-if="item.name === '在孵各类企业总数'">{{
                  gardenInfoList.incubationArg02 ? gardenInfoList.incubationArg02 : '-'
                }}</span>
                <span class="DataNum" v-if="item.name === '在孵留创企业数'">{{
                  gardenInfoList.incubationArg03 ? gardenInfoList.incubationArg03 :'-'
                }}</span>
                <span
                  class="DataNum"
                  v-if="item.name === '累计孵化留创企业数'"
                  >{{ gardenInfoList.incubationArg04 ? gardenInfoList.incubationArg04 :'-' }}</span
                >
                <span
                  class="DataNum"
                  v-if="item.name === '高新技术留创企业数'"
                  >{{ gardenInfoList.incubationArg05 ? gardenInfoList.incubationArg05 :'-' }}</span
                >
                <span
                  class="DataNum"
                  v-if="item.name === '在孵留创企业注册资本（万元）'"
                  >{{ gardenInfoList.incubationArg06 ? gardenInfoList.incubationArg06 :'-' }}</span
                >
                <span
                  class="DataNum"
                  v-if="item.name === '留创企业上一年营业收入（万元）'"
                  >{{ gardenInfoList.incubationArg07 ? gardenInfoList.incubationArg07 : '-' }}</span
                >
                <span
                  class="DataNum"
                  v-if="item.name === '留创企业上一年税收贡献（万元）'"
                  >{{ gardenInfoList.incubationArg08 ? gardenInfoList.incubationArg08 : '-' }}</span
                >
                <span
                  class="DataNum"
                  v-if="item.name === '留创企业知识产权数'"
                  >{{ gardenInfoList.incubationArg09 ? gardenInfoList.incubationArg09 :'-' }}</span
                >
                <span class="DataNum" v-if="item.name === '在园留学人数'">{{
                  gardenInfoList.incubationArg10 ? gardenInfoList.incubationArg10 : '-'
                }}</span>
                <span class="DataNum" v-if="item.name === '高层次留学人才数'">{{
                  gardenInfoList.incubationArg11 ? gardenInfoList.incubationArg11 :'-'
                }}</span>
                <span class="DataName">{{ item.name }}</span>
              </p>
            </div>
            <el-carousel
              class="survey-img"
              style="height: 690px"
              indicator-position="outside"
            >
              <el-carousel-item
                style="height: 622px"
                v-for="(item, index) in surveyImgList"
                :key="index"
              >
                <img style="width: 953px; height: 622px" :src="item" alt="" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="houseing" id="houseing" v-if="gardenDataHousingView != null">
            <span class="title"
              >房源信息
              <span class="hot-call"
                >看房热线：{{gardenDataHousingView !==null ? gardenDataHousingView.apartmentConsultPhone : null}}</span
              >
            </span>
<!--            <p class="content">{{ gardenDataHousingView.apartmentInfo }}</p>-->
            <p class="content">{{ gardenDataHousingView.apartmentInfo }}</p>

            <div>
              <div class="housing-work">
                <el-tabs
                  v-model="activeName"
                  type="card"
                  @tab-click="handleClick"
                >
                  <el-tab-pane
                    v-for="(item, index) in workHouse"
                    :key="index"
                    :label="item.lable"
                    :name="item.name">

                    <span class="house-info" v-if="activeName === 'common' && rentOutInfo.common">
                      租金区间：{{rentOutInfo.common==null?0:rentOutInfo.common.commonRentSection !== null ? rentOutInfo.common.commonRentSection : 0  }} 元/㎡·天
                      <!-- {{rentOutInfo.common.commonRentSection}}$$$$$$$$$ -->
                    </span>
                    <span class="house-info" v-if="activeName === 'share'">
                      租金区间：{{rentOutInfo.share.shareRentSection }} 元/㎡·天
                    </span>
                    <el-divider direction="vertical"></el-divider>

                    <span class="house-info" v-if="activeName === 'common'" >
                     在租房源：{{rentOutInfo.common==null?0:rentOutInfo.common.commonInLifeHousing!== null ?rentOutInfo.common.commonInLifeHousing:0}}个</span>
                    <span class="house-info" v-if="activeName === 'share'">
                      在租房源：{{rentOutInfo.share==null?0:rentOutInfo.share.shareInLifeHousing!==null?rentOutInfo.share.shareInLifeHousing:0 }}个</span>
                    <el-divider direction="vertical"></el-divider>

                    <span class="house-info" v-if="activeName === 'common'" >
                      面积区间：{{ rentOutInfo.common==null?0:rentOutInfo.common.commonAreas!==null?rentOutInfo.common.commonAreas:0 }}㎡
                    </span>
                    <span class="house-info" v-if="activeName === 'share'">
                      面积区间：{{ rentOutInfo.share==null?0:rentOutInfo.share.shareAreas!==null?rentOutInfo.share.shareAreas:0 }}㎡
                    </span>

                    <div class="house-img" v-if="activeName === 'common'">
                      <div class="leftArrow">
                        <el-button
                          class="leftArrow-btn"
                          size="mini"
                          icon="el-icon-arrow-up"
                          circle
                          @click="prev">
                       </el-button>
                      </div>
                      <el-carousel
                        height="617px"
                        direction="vertical"
                        :autoplay="false"
                        trigger="click"
                        arrow="never"
                        ref="cardShow" >
                          <el-carousel-item
                            class="item-img-tit"
                            v-for="(item, index) in commonHouseImgList"
                            :key="index"
                            :label="item.split('s_e_prator').slice(-1).join()">
                            <img :src="item" alt="" />
                          </el-carousel-item>
                      </el-carousel>

                      <div class="rightArrow">
                        <el-button
                          class="leftArrow-btn"
                          size="mini"
                          icon="el-icon-arrow-down"
                          circle
                          @click="next">
                        </el-button>
                      </div>
                    </div>

                    <div class="house-img" v-if="activeName === 'share'">
                      <div class="leftArrow">
                        <el-button
                          class="leftArrow-btn"
                          size="mini"
                          icon="el-icon-arrow-up"
                          circle
                          @click="prev">
                       </el-button>
                      </div>
                      <el-carousel
                        height="617px"
                        direction="vertical"
                        :autoplay="false"
                        trigger="click"
                        arrow="never"
                        ref="cardShow" >
                          <el-carousel-item
                            class="item-img-tit"
                            v-for="(item, index) in shareHouseImgList"
                            :key="index"
                            :label="item.split('s_e_prator').slice(-1).join()">
                            <img :src="item" alt="" />
                          </el-carousel-item>
                      </el-carousel>

                      <div class="rightArrow">
                        <el-button
                          class="leftArrow-btn"
                          size="mini"
                          icon="el-icon-arrow-down"
                          circle
                          @click="next">
                        </el-button>
                      </div>
                    </div>

                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>

          <div class="policy" id="policy">
            <span class="title"
              >招商政策
              <span class="hot-call"
                >招商热线：{{InvestDataList.investmentConsultPhone !==null ? InvestDataList.investmentConsultPhone : ''}}</span
              >
            </span>
            <p class="content" v-html="InvestDataList.investmentPolicy"></p>
          </div>

          <div class="serve" id="serve">
            <span class="title">园区服务</span>
            <p class="content">{{ ServeDataList.serviceDescribe }}</p>
            <div>
              <p class="base-serve"></p>
              <span class="serve-word">基础服务</span>
              <div>
                <p
                  class="serve-tit"
                  v-for="(item, index) in baseServe"
                  :key="index"
                >
                  {{ item }}
                </p>
              </div>
            </div>
            <div>
              <p class="base-serve"></p>
              <span class="serve-word">企业服务</span>
              <div>
                <p
                  class="serve-tit"
                  v-for="(item, index) in companyServe"
                  :key="index"
                >
                  {{ item }}
                </p>
              </div>
            </div>
          </div>

          <div class="periphery" id="periphery" v-if="SurroundData != null">
            <span class="title">周边配套</span>
            <p class="content">{{ SurroundData?SurroundData.supportFacility:null }}</p>
            <div style="width: 950px; height: 400px; position: relative">
              <div style="height: 100%; width: 100%" id="containers"></div>
              <div class="menu">
                <div class="nav">
                  <p
                    :class="navIdx == 0 ? 'navList2' : 'navList'"
                    @click="navBtn(0, '交通')"
                  >
                    交通
                  </p>
                  <p
                    :class="navIdx == 1 ? 'navList2' : 'navList'"
                    @click="navBtn(1, '餐饮')"
                  >
                    餐饮
                  </p>
                  <p
                    :class="navIdx == 2 ? 'navList2' : 'navList'"
                    @click="navBtn(2, '娱乐')"
                  >
                    娱乐
                  </p>
                  <p
                    :class="navIdx == 3 ? 'navList2' : 'navList'"
                    @click="navBtn(3, '银行')"
                  >
                    银行
                  </p>
                  <p
                    :class="navIdx == 4 ? 'navList2' : 'navList'"
                    @click="navBtn(4, '酒店')"
                  >
                    酒店
                  </p>
                  <p
                    :class="navIdx == 5 ? 'navList2' : 'navList'"
                    @click="navBtn(5)"
                    style="flex: 2"
                  >
                    周边楼盘
                  </p>
                </div>
                <div class="menuDetail">
                  <div id="panel" style="width: 100%"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="honor" id="honor">
            <span class="title">荣誉资质</span>
            <p class="content" v-html="HonorDataList.honorIntroduction"></p>
            <el-carousel class="slideshow-project" indicator-position="outside">
              <el-carousel-item
                class="project-item"
                v-for="(items, indexs) in GetAwardprojects"
                :key="indexs"
              >
                <div
                  class="project"
                  v-for="(item, index) in items"
                  :key="index"
                >
                  <img :src="item.trim()" alt="" />
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>

          <div class="gardenFirm" id="gardenFirm">
            <span class="title">园区企业</span>
            <div class="garden-firm">
              <el-form
                class="search-form"
                ref="form"
                :model="form"
                label-width="85px"
              >
                <el-form-item label="所属地区：">
                  <el-select
                    class="frame"
                    v-model="form.area"
                    placeholder="请选择地区"
                  >
                    <el-option
                      v-for="item in countryCity"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="产业分类：">
                  <el-select
                    class="frame"
                    v-model="form.classify"
                    placeholder="请选择产业"
                  >
                    <el-option
                      v-for="(item, index) in classifyList"
                      :key="index"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="注册资本：">
                  <el-input
                    class="frame"
                    v-model="form.registerCapital"
                    placeholder="请填写注册资本"
                  ></el-input>
                </el-form-item>

                <el-form-item label="融资轮次：">
                  <el-select
                    class="frame"
                    v-model="form.financing"
                    placeholder="请选择融资轮次"
                  >
                    <el-option
                      v-for="(item, index) in financingList"
                      :key="index"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="成立时间：">
                  <el-date-picker
                    class="frame"
                    v-model="form.time"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item label="企业名称：">
                  <el-input
                    class="frame"
                    v-model="form.capital"
                    placeholder="请填写企业名称"
                  ></el-input>
                </el-form-item>

                <el-form-item class="btn">
                  <el-button class="inquire" @click="getGardenFirm"
                    >查询</el-button
                  >
                  <el-button class="reset" @click="reset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>

            <div>
              <el-table
                class="firm-data"
                :data="tableData"
                border
                style="width: 1161px"
              >
                <el-table-column fixed type="index" label="序号" width="50">
                </el-table-column>

                <el-table-column prop="district" label="区域" width="150">
                  <template slot-scope="scope">{{ scope.row.district || "-" }}</template>
                </el-table-column>

                <el-table-column prop="name" label="企业名称" width="210">
                  <template slot-scope="scope">{{ scope.row.name || "-" }}</template>
                </el-table-column>

                <el-table-column prop="industry" label="行业分类" width="210">
                 <template slot-scope="scope">{{ scope.row.industry || "-" }}</template>
                </el-table-column>

                <el-table-column
                  prop="foundation_date"
                  label="成立时间"
                  width="120"
                >
                 <template slot-scope="scope">{{ scope.row.foundation_date || "-" }}</template>
                </el-table-column>

                <el-table-column
                  prop="registryCapital"
                  label="注册资本"
                  width="120"
                >
                 <template slot-scope="scope">{{ scope.row.registryCapital || "-" }}</template>
                </el-table-column>

                <el-table-column
                  prop="financialTurn"
                  label="融资轮次"
                  width="100"
                >
                 <template slot-scope="scope">{{ scope.row.financialTurn || "-" }}</template>
                </el-table-column>
              </el-table>
            </div>

            <paging
              :totalPage="totalPage"
              :pageSize="size"
              :CurrentPage="page"
              @curentPage="handleCurrentChange"
            >
            </paging>
          </div>

          <div class="figureGarden" id="figureGarden">
            <span class="title">数字园区</span>
            <img
              v-if="FigureDataList.thumbnail"
              class="figure-video"
              :src="FigureDataList.thumbnail"
              @click="checkVideoFun(FigureDataList.video)"
            />
            <img class="figure-video" v-else src="../../assets/home/lostImg.png" alt="" />

            <div
              class="figureGarden-btn"
              @click="goFigureWeb(FigureDataList.website)"
            >
              访问数字园区网站
            </div>
            <div
              class="mask"
              v-if="videoState == true"
              @click="masksCloseFun"
            ></div>
            <div class="videomasks" v-if="videoState == true">
              <video :src="FigureDataList.video" controls="controls" autoplay></video>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- <div class="returnTop" @click="thisTop">
      <div class="top-arrows"><img src="@/assets/home/topArrows.png" alt=""></div>
      <div class="top-word">回到顶部</div>
    </div> -->
<!--    <return-top></return-top>-->
  </div>
</template>

<script>
// import ReturnTop from '@/components/returnTop.vue'
import Paging from '@/components/paging.vue'
import mixinFun from '@/utils/mixin'
import MapLoader from '@/utils/loadAMap'
export default {
  name: 'gardenDetail',
  props: {
    outsideData: {
      type: Object,
      default: null
    }
  },
  mixins: [mixinFun],
  components: {
    // ReturnTop,
    Paging
  },
  data () {
    return {
      itemClickItem: null,
      itemHoverIndex: null, // 鼠标移入索引
      pageNavList: [
        {
          id: 'survey',
          name: '园区概况'
        },
        {
          id: 'houseing',
          name: '房源信息'
        },
        {
          id: 'policy',
          name: '招商政策'
        },
        {
          id: 'serve',
          name: '园区服务'
        },
        {
          id: 'periphery',
          name: '周边配套'
        },
        {
          id: 'honor',
          name: '荣誉资质'
        },
        {
          id: 'gardenFirm',
          name: '园区企业'
        },
        {
          id: 'figureGarden',
          name: '数字园区'
        }
      ],

      gardenInfoList: {},
      baseDataList: [
        {
          index: '1',
          name: '建园时间',
          num: '305'
        },
        {
          index: '2',
          name: '孵化面积（平方公里）',
          num: '10,000,000'
        },
        {
          index: '3',
          name: '在孵各类企业总数',
          num: '8,000'
        },
        {
          index: '4',
          name: '在孵留创企业数',
          num: '2,000'
        },
        {
          index: '5',
          name: '累计孵化留创企业数',
          num: '9,000'
        },
        {
          index: '6',
          name: '高新技术留创企业数',
          num: '3000'
        },
        {
          index: '7',
          name: '在孵留创企业注册资本（万元）',
          num: '2000'
        },
        {
          index: '8',
          name: '留创企业上一年营业收入（万元）',
          num: '1000'
        },
        {
          index: '9',
          name: '留创企业上一年税收贡献（万元）',
          num: '5000'
        },
        {
          index: '10',
          name: '留创企业知识产权数',
          num: '1,000'
        },
        {
          index: '11',
          name: '在园留学人数',
          num: '1,000'
        },
        {
          index: '12',
          name: '高层次留学人才数',
          num: '100,000'
        }
      ],
      surveyImgList: [],
      gloryTag: [], // 荣誉称号标签
      isBase: false, // 孵化基地标签

      rentOutInfo: {},
      commonHouseImgList: [],
      shareHouseImgList: [],
      houseImgList: [
        { name: 'A房间展示', img: require('@/assets/home/abroadGarden1.png') },
        {
          name: 'B房间展示',
          img: require('@/assets/firm-garden/introduce-img.png')
        },
        { name: 'C房间展示', img: require('@/assets/home/abroadGarden2.png') }
      ],
      projects: [],
      GetAwardprojects: [], // 双层数组嵌套获奖项目数据
      activeName: 'common',
      workHouse: [
        {
          lable: '普通办公',
          name: 'common'
        },
        {
          lable: '共享办公',
          name: 'share'
        }
      ],
      baseServe: [], // 基础服务
      companyServe: [], // 企业服务

      InvestDataList: {},
      ServeDataList: {},
      HonorDataList: {},
      FigureDataList: {},

      form: {
        classify: null,
        area: null,
        capital: null,
        financing: null,
        time: null,
        registerCapital: null
      },
      tableData: [],

      countryCity: [{ id: -1, name: '全国', pid: 0 }], // 全国34个省市
      classifyList: [], // 所有行业分类
      financingList: ['种子轮', '天使轮', 'A轮', 'B轮', 'C轮', 'D轮'], // 融资轮次

      totalPage: 0, // 总页数
      page: 1, // 默认页码
      size: 10, // 每页数据条数

      videoSrc: '', // 数字园区视频
      videoState: false,
      dialogVisible: false, // 视频会话框

      lat: '', // 地图数据
      lng: '', // 地图数据
      map: null,
      navIdx: 0,
      mapObj: {},
      gardenDataHousingView: {},
      SurroundData: []
    }
  },
  computed: {},
  created () {
    // console.log('preview created-----------------')
    this.getDetailData()
    this.getFirstCity()
    this.getClassify()
    this.getGardenFirm()
  },
  mounted () {
    document.documentElement.scrollTop = 0
    this.getDetailData()
    this.$nextTick(() => {})
  },
  methods: {
    thisTop () {
      // console.log('顶部')
      document
        .querySelector('#survey')
        .scrollIntoView({ behavior: 'smooth', block: 'center' })
    },
    // 展示地图
    navBtn (idx, label) {
      var that = this
      that.navIdx = idx
      this.keywords = label
      that.MapLoader(that.lat, that.lng)
    },
    // 拿到地图数据
    getGardenBaseInfo () {
      // const SurroundData = JSON.parse(sessionStorage.getItem('LsurroundingInfo'))
      // if (SurroundData != null) return
      // 服务器拿不到数据

      // this.SurroundData = SurroundData
      this.SurroundData = { location: '39.907088,116.47639,北京市朝阳区大望路', supportFacility: '哈哈哈哈哈哈哈哈哈哈' }
      if (this.SurroundData.location) {
        this.lat = this.SurroundData.location.split(',')[0]
        this.lng = this.SurroundData.location.split(',')[1]
        this.mapObj.location = this.SurroundData.location.split(',')[2]
        this.MapLoader(this.lat, this.lng)
      }
    },
    // 创建地图搜索
    searchNear () {
      this.$nextTick(() => {
        // 渲染完毕再执行这个，所以才能没有延时的更改
        const that = this
        MapLoader({ plugins: ['AMap.PlaceSearch', 'AMap.Geolocation'] }).then(
          (AMap) => {
            AMap.service(['AMap.PlaceSearch'], function () {
              // 构造地点查询类
              var placeSearch = new AMap.PlaceSearch({
                type: '地铁', // 兴趣点类别
                pageSize: 5, // 单页显示结果条数
                pageIndex: 1, // 页码
                citylimit: true, // 是否强制限制在设置的城市内搜索
                map: that.map, // 展现结果的地图实例
                panel: 'panel', // 结果列表将在此容器中进行展示。
                autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
              })
              AMap.event.addListener(
                placeSearch,
                'listElementClick',
                function (e) {
                  // console.log(e)
                  // let val = that.distanceFn([
                  //   e.data.location.lat,
                  //   e.data.location.lng,
                  // ]);
                  // console.log(e.data.location.lat, e.data.location.lng);
                  that.$message(`当前距离您有${e.data.distance}米`)
                }
              )
              const cpoint = [that.lng, that.lat]
              // let keywords = "酒店", // 关键字
              // position = [104.070081, 30.581108], // 中心点经纬度
              const radius = 2000 // 搜索半径 0-50000
              console.log(that.keywords)
              placeSearch.searchNearBy(
                that.keywords,
                cpoint,
                radius,
                function (status, result) {
                  // eslint-disable-next-line no-new
                  new AMap.Marker({
                    position: cpoint, // 不同标记点的经纬度s
                    // icon: "http://store.is.autonavi.com/showpic/2f754f895d410592bdf46eeddc379bee",//中心点icon
                    title: 'aaa',
                    clickable: true,
                    map: that.map
                  })
                  if (result.poiList) {
                    for (let i = 0; i < result.poiList.pois.length; i++) {
                      // eslint-disable-next-line no-new
                      new AMap.Marker({
                        position: [
                          result.poiList.pois[i].location.lng,
                          result.poiList.pois[i].location.lat
                        ], // 不同标记点的经纬度
                        // icon: "http://store.is.autonavi.com/showpic/2f754f895d410592bdf46eeddc379bee",
                        title: result.poiList.pois[i].name,
                        clickable: true,
                        map: that.map
                      })
                    }
                  }
                  // console.log(status, result, '结果') // 这个结果可以看出周边的很多信息列表，根据结果做很多事，如果要翻页，请移步官网 在此如有需要  附链接https://lbs.amap.com/api/webservice/guide/api/newpoisearch
                }
              )
            })
          }
        )
      })
      // console.log(this.lng, this.lat)
    },

    // 初始化从地图
    MapLoader (lat, lng, list) {
      var that = this
      MapLoader().then(
        (AMap) => {
          console.log('地图加载成功')
          that.map = new AMap.Map('containers', {
            center: [lng, lat],
            resizeEnable: true,
            zoom: 13
          })
          // 点标记
          var marker = new AMap.Marker({
            position: new AMap.LngLat(lng, lat), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: '北京',
            icon: new AMap.Icon({
              image: 'https://testoss.functionradian4.com/addressIcon.png',
              size: new AMap.Size(100, 100),
              imageSize: new AMap.Size(40, 40)
            })
          })
          // console.log(marker)
          that.map.add(marker)
          // 圆覆盖
          var circle = new AMap.Circle({
            center: new AMap.LngLat(lng, lat), // 圆心位置
            radius: 2000, // 圆半径
            fillColor: 'rgba(168, 167, 242,0.6)', // 圆形填充颜色
            strokeColor: '#fff', // 描边颜色
            strokeWeight: 1 // 描边宽度
          })
          that.map.add(circle)
          that.searchNear(that.map)
          // this.iptSearch();
        },
        (e) => {
          console.log('地图加载失败', e)
        }
      )
    },
    //  页面锚点
    toModule (id, index) {
      this.itemClickItem = index
      if (id === 'survey') {
        document
          .querySelector('#survey')
          .scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'houseing') {
        document
          .querySelector('#houseing')
          .scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'policy') {
        document
          .querySelector('#policy')
          .scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'serve') {
        document
          .querySelector('#serve')
          .scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'periphery') {
        document
          .querySelector('#periphery')
          .scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'honor') {
        document
          .querySelector('#honor')
          .scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'gardenFirm') {
        document
          .querySelector('#gardenFirm')
          .scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      if (id === 'figureGarden') {
        document
          .querySelector('#figureGarden')
          .scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    },

    // 鼠标移入移出
    mouseEnter (index) {
      this.itemHoverIndex = index
      this.itemClickItem = index
    },
    mouseLeave () {
      this.itemHoverIndex = null
    },

    prev () {
      this.$refs.cardShow[0].prev()
    },
    next () {
      this.$refs.cardShow[0].next()
    },

    // 获取详情页数据
    getDetailData () {
      try {
        this.getGardenBaseInfo()

        // 概况信息
        // this.isBase = null
        // this.gardenInfoList = null
        // const data = JSON.parse(sessionStorage.getItem('gardenDataSurveyView'))
        const data = JSON.parse(sessionStorage.getItem('LsurveyInfo'))
        this.isBase = data.isPrior
        this.gardenInfoList = data
        // console.log(this.gardenInfoList)
        // console.log(data)

        if (data.basementScene) {
          this.surveyImgList = data.basementScene.split(',')
        }
        if (data.glory) {
          this.gloryTag = data.glory.split(',')
        }

        // 房源信息
        // this.rentOutInfo = null
        // this.commonHouseImgList = null
        // this.shareHouseImgList = null
        // const housingData = JSON.parse(sessionStorage.getItem('gardenDataHousingView'))
        const housingData = JSON.parse(sessionStorage.getItem('LhousingInfo'))
        console.log(housingData)
        if (housingData == null) return
        this.gardenDataHousingView = housingData
        if (housingData) {
          if (housingData.priceRange !== null) {
            this.rentOutInfo = JSON.parse(housingData.priceRange)
            this.commonHouseImgList = this.rentOutInfo.common.commonImg
            this.shareHouseImgList = this.rentOutInfo.share.shareImg
          }
        }

        // 招商信息
        // this.InvestDataList = null
        // const InvestData = JSON.parse(sessionStorage.getItem('gardenDataInvestView'))
        const InvestData = JSON.parse(sessionStorage.getItem('LinvestmentInfo'))
        if (InvestData !== null) {
          this.InvestDataList = InvestData
        }

        // 园区服务
        // this.ServeDataList = null
        // const ServeData = JSON.parse(sessionStorage.getItem('gardenDataServeView'))
        const ServeData = JSON.parse(sessionStorage.getItem('LgardenServeInfo'))
        if (ServeData !== null) {
          this.ServeDataList = ServeData
          // console.log(this.ServeDataList)
          if (this.ServeDataList.basicService) {
            this.baseServe = this.ServeDataList.basicService.split(',')
          }
          if (this.ServeDataList.companyService) {
            this.companyServe = this.ServeDataList.companyService.split(',')
          }
          this.isBase = this.ServeDataList.isPrior
        }

        // 荣誉资质
        // this.HonorDataList = null
        // const HonorData = JSON.parse(sessionStorage.getItem('gardenDataHonorView'))
        const HonorData = JSON.parse(sessionStorage.getItem('LhonorInfo'))
        if (HonorData !== null) {
          this.HonorDataList = HonorData
          // 荣誉资质图片
          if (this.HonorDataList.honorPicture) {
            this.projects = this.HonorDataList.honorPicture.split(',')
          }
          const sumStr = []
          const index = Math.ceil(this.projects.length / 6)
          for (let i = 0; i < index; i++) {
            const passStr = this.projects.splice(0, 6)
            sumStr.push(passStr)
          }
          this.GetAwardprojects = sumStr
        }

        // 数字园区
        // this.FigureDataList = null
        // const FigureData = JSON.parse(sessionStorage.getItem('gardenDataFigureView'))
        const FigureData = JSON.parse(sessionStorage.getItem('LfigureInfo'))
        if (FigureData !== null) {
          this.FigureDataList = FigureData
        }
        // 周边配套
        // this.SurroundData = null
        // const SurroundData = JSON.parse(sessionStorage.getItem('gardenDataSurroundView'))
        const SurroundData = JSON.parse(sessionStorage.getItem('LsurroundingInfo'))
        if (SurroundData != null) {
          this.SurroundData = SurroundData
        }
      } catch (err) {
        console.log(err)
      }
      // console.log('bbbb')
    },

    // 获取全国34个省市
    async getFirstCity () {
      try {
        const res = await this.$get(this.$url.base.commonCity)
        const { code, msg, data } = res.data

        if (code === 200 && data) {
          this.countryCity = this.countryCity.concat(data)
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 获取行业分类数据
    async getClassify () {
      try {
        const res = await this.$get(this.$url.activity.firmClassify)
        const { code, msg, data } = res.data
        if (code === 200 && data) {
          this.classifyList = data
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 获取园区企业列表
    async getGardenFirm () {
      if (this.form.registerCapital === '') {
        this.form.registerCapital = null
      }
      try {
        const res = await this.$post(this.$url.garden.GardenFirmList, {
          basementId: this.$route.query.id,
          isPublished: 1,
          district: this.form.area, // 所属地区
          realm: this.form.classify, // 产业分类
          registerCapital: this.form.registerCapital, // 注册资本
          turn: this.form.financing, // 融资轮次
          setUpDate: this.form.time, // 成立时间
          name: this.form.capital, // 企业名称
          page: this.page,
          size: this.size
        })

        const { code, msg, data } = res.data
        if (code === 200) {
          this.totalPage = data.total
          this.tableData = data.data
          this.tableData.map((item) => {
            if (item.foundation_date) {
              item.foundation_date = item.foundation_date.split(' ')[0]
            }
          })
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 重置
    reset () {
      this.form.area = null
      this.form.classify = null
      this.form.financing = null
      this.form.registerCapital = null
      this.form.capital = null
      this.form.time = null
      this.getGardenFirm()
    },

    // 分页功能
    handleCurrentChange (page) {
      this.page = page
      this.getGardenFirm()
    },

    // 跳转数字园区网站
    goFigureWeb (url) {
      if (url === null) { return }

      if (url.indexOf('https://') !== -1) {
        url.replace('https://', 'http://')
        window.open(url)
      } else if (url.indexOf('http://') !== -1) {
        window.open(url)
      } else {
        window.open('http://' + url)
      }
    },

    // 弹出层播放视频
    checkVideoFun (videos) {
      // console.log('checkVideoFun')
      // console.log(videos)
      this.videoState = true
      this.videoSrc = videos
    },
    masksCloseFun () {
      this.videoState = false
    },

    handleClick (tab, event) {
      console.log(tab, event)
    }
  }
}
</script>

<style scoped lang="less">
.gardenDetail {
  width: 100%;
  min-height: 100vh;
  margin-top: 8px;
  background-color: #f5f5f5;
  border: 1px solid #f5f5f5;
}
.garden-detail {
  width: 1200px;
  margin: 10px auto 0;
}
.garden-detail-main {
  display: flex;
  .garden-tits {
    position: sticky;
    top: 0;
    width: 190px;
    height: 470px;
    background-color: #fff;
    margin: 10px 20px 0 0;
    cursor: pointer;
    .garden-tit {
      text-align: center;
      margin-top: 20px;
      font-size: 20px;
    }
  }
  .garden-main {
    width: 1003px;
    min-height: 800px;
    background-color: #fff;
    margin: 10px 0 100px;
    box-sizing: border-box;
    padding: 30px 20px;
    .honor {
      /deep/.el-carousel__arrow {
        top: 72%;
      }
      /deep/.el-carousel__button {
        width: 46px;
        height: 9px;
        background: #3056d9;
        border-radius: 3px;
      }
    }
    .survey {
      /deep/.el-carousel__button {
        width: 46px;
        height: 9px;
        background: #3056d9;
        border-radius: 3px;
      }
    }
    .survey,
    .houseing,
    .policy,
    .serve,
    .periphery,
    .honor,
    .gardenFirm,
    .figureGarden {
      box-sizing: border-box;
      .title {
        display: inline-block;
        padding-left: 10px;
        font-size: 20px;
        border-left: 4px solid #3056d9;
        border-radius: 1px 0 0 1px;
        margin: 38px 0 20px;
        .hot-call {
          margin-left: 20px;
        }
      }
    }
    .garden-intro {
      display: flex;
      .garden-logo {
        width: 179px;
        height: 128px;
      }
      .base-info {
        margin-left: 20px;
        .info-tit {
          font-size: 20px;
        }
        .tag-style {
          display: inline-block;
          box-sizing: border-box;
          padding: 5px 10px;
          margin: 10px 10px 15px 0;
          font-size: 12px;
        }
        .tag-style:nth-of-type(3n-2) {
          background-color: #fbf5e7;
          color: #926602;
        }
        .tag-style:nth-of-type(3n-1) {
          background-color: #fff3ee;
          color: #8a3217;
        }
        .tag-style:nth-of-type(3n) {
          background-color: #e8f6ff;
          color: #173c8e;
        }
        .icon-info {
          box-sizing: border-box;
          display: inline-block;
          font-size: 12px;
          color: #898b91;
          margin: 0 0 8px 8px;
        }
      }
    }
    .info-content {
      font-size: 12px;
      color: #898b91;
      line-height: 20px;
      margin-top: 25px;
      overflow: hidden;
    }
    .content {
      font-size: 16px;
      line-height: 20px;
      color: #8f9096;
      margin-bottom: 10px;
    }
    .house-info {
      display: inline-block;
      padding-bottom: 20px;
    }
    .house-img {
      position: relative;
      width: 100%;
      height: 617px;
      background-color: #ccc;
      .leftArrow {
        position: absolute;
        z-index: 20;
        top: 20px;
        left: 46px;
        width: 27px;
        height: 27px;
        color: #fff;

        .leftArrow-btn {
          background-color: rgba(255, 255, 255, 0.2);
          color: #fff;
          border: 0;
        }
      }
      .rightArrow {
        position: absolute;
        z-index: 20;
        bottom: 20px;
        left: 46px;
        width: 27px;
        height: 27px;
        color: #fff;
        margin-top: 100px;

        .leftArrow-btn {
          background-color: rgba(255, 255, 255, 0.2);
          color: #fff;
          border: 0;
        }
      }
      img {
        width: 960px;
        height: 617px;
      }
      /deep/.el-carousel__indicators--labels {
        left: 0;
        top: 0;
      }

      /deep/.el-carousel__indicators--vertical {
        background-color: rgba(0, 0, 0, 0.5);
        width: 125px;
        // height: 617px;
        height: 517px;
        // box-sizing: border-box;
        padding: 70px 0;
        // margin: 70px 0;
        overflow: hidden !important;
        left: 0;
      }
      /deep/.el-carousel__button {
        width: 100px;
        height: 32px;
        margin-left: 10px;
        font-size: 14px;
        padding: 0;
        color: #fff;
        background-color: transparent;
      }
      /deep/.is-active {
        font-size: 14px;
        text-align: center;
        background-color: transparent !important;
      }
      /deep/.is-active > .el-carousel__button {
        width: 100px;
        height: 32px;
        background-color: rgba(255, 255, 255, 0.3);
      }
      /deep/.el-carousel__arrow {
        background-color: #000;
      }
    }
    .Data {
      display: flex;
      flex-wrap: wrap;
      width: 950px;
      height: 366px;
      background-color: #fff;
      box-shadow: 0px 2px 10px 0px rgba(164, 164, 164, 0.5);
      border-radius: 10px;
      margin: 25px 0 32px;
      .specificData {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 235px;
        height: 122px;
        box-sizing: border-box;
        text-align: center;
        .DataNum {
          font-size: 30px;
          font-weight: 600;
        }
        .DataName {
          font-size: 15px;
          color: #b8bfc5;
          margin-top: 10px;
        }
      }
    }
    .slideshow-project {
      width: 955px;
      height: 530px;
      box-sizing: border-box;
      // border: 1px solid red;
      // margin: 20px 0 0;
      .project-item {
        display: flex;
        flex-wrap: wrap;
        height: 450px;
        // border: 1px solid blue;
        .project {
          margin-right: 20px;
          img {
            width: 303px;
            height: 216px;
          }
        }
        .project:nth-of-type(3n) {
          margin-right: 0;
        }
      }
      /deep/.el-carousel__indicators {
        // border: 1px solid blueviolet;
        margin-top: 180px !important;
      }
    }
    .survey-img {
      /deep/.el-carousel__indicators {
        margin-top: 20px;
      }
      /deep/.el-carousel__container {
        height: 622px;
      }
    }
    .housing-work {
      /deep/.el-tabs--card > .el-tabs__header {
        border-bottom: 0;
      }
      /deep/.el-tabs__item {
        background-color: #f0f2f5;
        color: #000;
        border: 1px solid #f0f2f5;
        margin-right: 10px;
        border-radius: 5px;
      }
      /deep/.el-tabs__nav {
        margin: 20px 0 10px 0;
        border: 0;
      }
      /deep/.is-active {
        background-color: #3056d9;
        color: #fff;
      }
      /deep/.el-divider--vertical {
        height: 1.2em;
        margin: 0 30px;
      }
      /deep/.el-divider {
        background-color: #000;
      }
    }
    .base-serve {
      display: inline-block;
      width: 10px;
      height: 10px;
      background-color: #3056d9;
      border-radius: 50%;
    }
    .serve-tit {
      padding: 10px 15px;
      margin: 0 20px 25px;
      display: inline-block;
      background: #ffffff;
      box-shadow: 0px 4px 14px 0px rgba(206, 206, 206, 0.5);
      border-radius: 1px;
    }
    .serve-word {
      display: inline-block;
      font-size: 16px;
      margin: 20px 0 20px 10px;
    }
    .garden-firm {
      display: flex;
      position: relative;
      .search-form {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        position: relative;
        .frame {
          width: 200px;
          // margin-right: 25px;
        }
        .btn {
          position: absolute;
          bottom: -60px;
          right: 0;
        }
        .inquire {
          background-color: #3056d9;
          color: #fff;
        }
        .reset {
          background-color: #f0f2f5;
          color: #000;
        }
      }
    }
    .firm-data {
      margin-top: 80px;
    }
    .figure-video {
      width: 950px;
      height: 529px;
    }
    .figureGarden-btn {
      width: 264px;
      height: 54px;
      line-height: 54px;
      text-align: center;
      background: #3056d9;
      border-radius: 10px;
      font-size: 18px;
      color: #fff;
      margin: 25px auto 74px;
    }
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 120;
      background-color: #000000;
      opacity: 0.6;
    }
    // 内容层 z-index要比遮罩大，否则会被遮盖
    .videomasks {
      min-width: 1400px;
      position: fixed;
      left: 50%;
      top: 50%;
      z-index: 150;
      transform: translate(-50%, -50%);
    }
    .videomasks video {
      width: 100%;
      height: 600px;
    }
  }
}

/deep/.is-leaf {
  background-color: #2b366c;
  font-size: 14px;
  color: #fff !important;
  text-align: center !important;
}
/deep/.el-table__row:nth-of-type(2n-1) {
  background-color: #fafafa;
}
/deep/.cell {
  text-align: center !important;
}

.itemHover {
  background: linear-gradient(180deg, #3056d9 0%, #1076ec 100%);
  box-shadow: 0px 2px 10px 0px rgba(164, 164, 164, 0.5);
  color: #ffffff !important;
  border-radius: 10px;
}

.itemClick {
  color: #3056d9;
}

.houseImgItemClick {
  background-color: rgba(255, 255, 255, 0.3);
}
.houseImgClick {
  z-index: 1000;
}

/deep/.is-link {
  font-size: 16px;
  font-weight: 400;
  color: #000 !important;
  text-decoration: underline;
}
.current-page {
  /deep/.el-breadcrumb__inner {
    color: #3c60db !important;
    text-decoration: none;
  }
}
.menuDetail {
  height: 280px;
  overflow: auto;
  .menuList {
    cursor: pointer;
    display: flex;
    margin: 10px 20px;
    align-items: center;
    .menuList-left {
      flex: 1;
    }
  }
}
.menu {
  cursor: pointer;
  width: 340px;
  height: 360px;
  background: #ffffff;
  position: absolute;
  right: 30px;
  top: 20px;
  .nav {
    display: flex;
    align-items: center;
    width: 100%;
    height: 30px;
    background: rgb(244, 245, 244);
    .navList {
      flex: 1;
      text-align: center;
      font-size: 14px;
      cursor: pointer;
    }
    .navList2 {
      flex: 1;
      text-align: center;
      font-size: 14px;
      cursor: pointer;
      background: #ffffff;
      height: 30px;
      line-height: 30px;
    }
  }
}
.returnTop{
  position: fixed;
  top: 500px;
  right: 43px;
  width: 47px;
  height: 77px;
  background: #FFFFFF;
  box-shadow: 0px 4px 14px 0px rgba(206, 206, 206, 0.5);
  border-radius: 8px;
  .top-arrows{
    width: 47px;
    height: 39px;
    line-height: 39px;
    text-align: center;
    background: #3056D9;
    border-radius: 8px 8px 0px 0px;
  }
  .top-word{
    width: 47px;
    height: 38px;
    padding: 6px 11px 0 ;
    box-sizing: border-box;
    background: #FFFFFF;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #252728;
    line-height: 13px;
    border-radius: 0px 0px 8px 8px;
  }
}
</style>
